import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useReducedMotion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

interface AccoladeDataType {
  quote: MessageKey;
  source: {
    name: string;
    logo: string;
    width: number;
  };
}

const accoladesData: AccoladeDataType[] = [
  {
    quote: 'simple_home_accolades_usa_today',
    source: {
      name: 'USA Today',
      logo: 'accolades/usa-today-logo.svg',
      width: 100,
    },
  },
  {
    quote: 'simple_home_accolades_architectural_digest',
    source: {
      name: 'Architectural Digest',
      logo: 'accolades/architectural-digest-logo.svg',
      width: 55,
    },
  },
  {
    quote: 'simple_home_accolades_washington_post',
    source: {
      name: 'Washington Post',
      logo: 'accolades/washington-post-logo.svg',
      width: 232,
    },
  },
];

const marqueeVariants = {
  animate: {
    x: ['0%', '-275%'],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: 'loop' as const,
        duration: 30,
        ease: 'linear' as const,
      },
    },
  },
};
const GiftMarquee = () => {
  const t = useTranslations();
  const prefersReducedMotion = useReducedMotion();
  const animate = !prefersReducedMotion ? 'animate' : false;
  const items = prefersReducedMotion
    ? accoladesData
    : [...accoladesData, ...accoladesData];

  return (
    <section className="overflow-hidden bg-sandstone-200 py-10">
      <Motion variants={marqueeVariants} animate={animate}>
        <ul className="inline-flex items-center">
          {items.map(({ quote, source }, idx) => {
            const isDuplicate = idx >= accoladesData.length;

            return (
              <li
                // Hide duplicated items from screen readers
                aria-hidden={isDuplicate}
                key={`${quote}-${isDuplicate ? 'dupe' : 'first'}`}
                className="flex shrink-0 items-center gap-8 pl-8 text-xl before:content-['\2022'] lg:text-3xl"
              >
                <blockquote className="inline-flex flex-row-reverse items-center gap-5">
                  <Typography
                    className="flex before:content-[open-quote] after:content-[close-quote]"
                    variant="unset"
                    weight="light"
                  >
                    {t(quote)}
                  </Typography>
                  <footer>
                    <cite>
                      <Image
                        src={source.logo}
                        alt={source.name}
                        width={source.width}
                        height={36}
                      />
                    </cite>
                  </footer>
                </blockquote>
              </li>
            );
          })}
        </ul>
      </Motion>
    </section>
  );
};

export default GiftMarquee;
